import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import classes from './BreadCrumbs.module.css';
import { getLinkLtik } from 'constants/LTIData';
const url = window.location.pathname.split('/');

const BreadCrumbs = props => {
  const { t } = useTranslation(['course']);
  return (
    <aside className={classes.breadCrumbsContainer}>
      {!getLinkLtik() && (
        <>
          <Button
            component={Link}
            to={url[2] === 'a' ? '/a' : '/'}
            className={classes.btnStatusLessonStart}
          >
            {t('start')}
          </Button>
          <ChevronRightIcon className={classes.breadCrumbIcon} />
        </>
      )}
      <Button
        component={Link}
        to={
          props.lesson && getLinkLtik()
            ? `/c/${props.idCourse}/?ltik=${getLinkLtik()}`
            : props.lesson && url[2] === 'a'
            ? `/a/c/${props.idCourse}`
            : `/c/${props.idCourse}`
        }
        disabled={!props.lesson}
        className={
          !props.lesson
            ? classes.btnStatusLesson
            : classes.btnStatusLessonStart
        }
      >
        <p>{props.title}</p>
      </Button>
      {props.lesson && (
        <>
          <ChevronRightIcon className={classes.breadCrumbIcon} />
          <Button disabled className={classes.btnStatusLessonStart}>
            <p>{props.lesson}</p>
          </Button>
        </>
      )}
    </aside>
  );
};

BreadCrumbs.propTypes = {
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  lesson: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number
};

export default BreadCrumbs;
